import React, { createContext, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const PartnerContext = createContext();
export const usePartner = () => useContext(PartnerContext);

export const PartnerProvider = ({ children }) => {
  const { partnerSlug } = useParams();
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const slug = partnerSlug || "physica"; // default
        const res = await fetch(`https://api-bookings.physica.fit/api/v1/partner/config/${slug}`);
        const data = await res.json();
        if (data.success) {
          // Normalize referral code so downstream uses a single key
          const normalizedConfig = {
            ...data.data,
            referralCode: data.data?.referralCode || data.data?.referral_code || "",
          };
          setConfig(normalizedConfig);

          // Inject CSS variables dynamically
          document.documentElement.style.setProperty("--partner-primary", data.data.primary_color);
          document.documentElement.style.setProperty("--partner-secondary", data.data.secondary_color);
        }
      } catch (err) {
        console.error("Partner config fetch failed:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchConfig();
  }, [partnerSlug]);

  return (
    <PartnerContext.Provider value={{ config, loading }}>
      {children}
    </PartnerContext.Provider>
  );
};
